import { Validators } from '@angular/forms';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { diseasesValidator } from '@shared/validators/diseases-validator';

export const venisafeValidationSet: ValidationPair = {
  children: {
    venisafe: {
      children: {
        patientHistory: {
          children: {
            cardiovascularConditions: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator()],
            },
            cardiovascularConditionsInFamily: {
              children: {
                hasHistory: {
                  validators: [Validators.required],
                },
              },
              validators: [diseasesValidator(true)],
            },
          },
        },
      },
    },
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientInformation: {
          children: {
            height: {
              validators: [Validators.required, Validators.min(0)],
            },
            weight: {
              validators: [Validators.required, Validators.min(0)],
            },
            ethnicity: {
              validators: [Validators.required],
            },
            ethnicitySelect: {
              validators: [Validators.required],
            },
          },
        },
      },
    },
  },
};
